








import { computed, defineComponent, PropType } from 'vue';

import i18n from '@/translate/lang';

export default defineComponent({
  name: 'CatalogFormBar',
  props: {
    label: String as PropType<string>,
  },
  setup(props, { emit }) {
    const orderButtonName = computed<string>(() => {
      const defaultButtonName = `${i18n.t('modules.catalog.form.action.send')}`;
      return props.label || defaultButtonName;
    });

    function onClick() {
      emit('click');
    }

    return { orderButtonName, onClick };
  },
});
